// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"section_title_sectionTitle__1EASd"};